import { Question, RespondingEntity } from 'Slices/Settings/SettingsSlice'
import AnswerCell from './AnswerCell'
import { SettingsName, defaultValue } from 'Constants/Settings'

interface AnswerColumnsProps {
  question: Question
  respondingEntities: RespondingEntity[]
}

function AnswersColumns(props: AnswerColumnsProps) {
  const generateAnswersCellsForColumn = (
    respondingEntities: RespondingEntity[] | null,
    question: Question,
    userCanEdit: boolean,
    isDefault: boolean = false,
  ) => {
    if (respondingEntities) {
      return respondingEntities.map((x: RespondingEntity) => {
        return (
          <div className='col' key={question.code + '-' + x.id + '-' + question.settingsName}>
            <AnswerCell question={question} respondingEntityId={x.id} userCanEdit={userCanEdit} />
          </div>
        )
      })
    }

    if (isDefault && question.isAllEnabled) {
      return (
        <div className='col'>
          <AnswerCell
            question={question}
            respondingEntityId={defaultValue}
            userCanEdit={userCanEdit}
            settingsName={question.settingsName}
          />
        </div>
      )
    }
    if (question.settingsName !== SettingsName.Application) {
      return <div className='col empty big-table-cell'></div>
    } else {
      return
    }
  }

  return (
    <div className='row child'>
      {generateAnswersCellsForColumn(null, props.question, true, true)}
      {generateAnswersCellsForColumn(props.respondingEntities, props.question, true)}
      <div>{/*Empty Column keep it for space*/}</div>
    </div>
  )
}

export default AnswersColumns
